
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ScrollArea } from "@/components/ui/scroll-area";
import { useClients } from "@/hooks/useClients";
import { UseFormReturn } from "react-hook-form";
import { DiscountFormValues } from "@/types/discount";
import { useState, useEffect } from "react";
import { Input } from "@/components/ui/input";
import { Search, Loader2 } from "lucide-react";

interface SchoolSelectProps {
  form: UseFormReturn<DiscountFormValues>;
}

export const SchoolSelect = ({ form }: SchoolSelectProps) => {
  const { clients, loading, handleSearchChange } = useClients();
  const [searchQuery, setSearchQuery] = useState("");

  // Update search when input changes
  useEffect(() => {
    handleSearchChange(searchQuery);
  }, [searchQuery, handleSearchChange]);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  return (
    <FormField
      control={form.control}
      name="school_id"
      render={({ field }) => (
        <FormItem>
          <FormLabel>School</FormLabel>
          <Select onValueChange={field.onChange} value={field.value}>
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder="Select a school" />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              <div className="flex items-center border-b px-3 py-2 sticky top-0 bg-background z-10">
                <Search className="mr-2 h-4 w-4 shrink-0 opacity-50" />
                <Input
                  placeholder="Search schools..."
                  className="h-8 border-0 p-0 bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0"
                  onChange={handleInputChange}
                  value={searchQuery}
                  onClick={(e) => e.stopPropagation()}
                />
              </div>
              <ScrollArea className="h-72 max-h-72">
                {loading ? (
                  <div className="flex justify-center items-center p-4">
                    <Loader2 className="h-6 w-6 animate-spin text-primary" />
                  </div>
                ) : clients.length > 0 ? (
                  clients.map((client) => (
                    <SelectItem key={client.school_id} value={client.school_id}>
                      {client.school_id} - {client.nama_sekolah}
                    </SelectItem>
                  ))
                ) : (
                  <div className="p-2 text-center text-sm text-muted-foreground">
                    No schools found
                  </div>
                )}
              </ScrollArea>
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
